import { Controller } from "@hotwired/stimulus"

// 関連ページURLの入力行を追加・削除する
export default class extends Controller {
  static targets = ["list", "template"]

  add() {
    this.listTarget.appendChild(this.templateTarget.content.cloneNode(true))
  }

  remove(event) {
    const row = event.target.closest("[data-url-list-target='row']")
    const rows = this.listTarget.querySelectorAll("[data-url-list-target='row']")
    if (rows.length > 1) {
      row.remove()
    } else {
      row.querySelector("input").value = ""
    }
  }
}
